import React from "react";
import { createRoot } from "react-dom/client";
import TicketStatusPegaIsland from "./TicketStatusPegaIsland";

const mountNode = document.getElementById("ticket-status-pega-island");

if (mountNode) {
  const rawConfig = mountNode.getAttribute("data-config");

  if (rawConfig) {
    const config = JSON.parse(rawConfig);
    createRoot(mountNode).render(<TicketStatusPegaIsland config={config} />);
  }
}
